import { toast } from "react-toastify";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import { useFieldArray, useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import moment from "moment";
import { Spinner } from "reactstrap";

export default function EmployeePreviousWork({
  locationData,
  pageStatesMain,
  setPageStatesMain,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit, control, setValue, clearErrors, watch, formState: { errors } } = useForm({
    defaultValues: {
      previousWork: [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "previousWork",
  });
  
  useEffect(() => {
    if (locationData?.previousworks?.length > 0) {
      const mappedData = locationData?.previousworks?.map((work, index) => {
        if (work.toDate === null) {
          setCurrentCompanyStates((prevState) => ({
            ...prevState,
            [index]: true,
          }));
        }
        
        return {
          ...work,
          fromDate: work.fromDate ? new Date(work.fromDate).toISOString().split("T")[0] : "",
          toDate: work.toDate ? new Date(work.toDate).toISOString().split("T")[0] : "",
        };
      });
        append(mappedData);
    }
  }, [locationData, append]);
  

  const [currentCompanyStates, setCurrentCompanyStates] = useState({});

  const handleCheckboxChange = (index, isChecked) => {
    const updatedStates = { ...currentCompanyStates, [index]: isChecked };
    setCurrentCompanyStates(updatedStates);

    if (isChecked) {
      // Disable `toDate` and remove validation
      setValue(`previousWork.${index}.toDate`, "");
      clearErrors(`previousWork.${index}.toDate`);
    }
  };



  const onSubmit = (data) => {
    const submitData = data?.previousWork?.map((work) => ({
      ...work,
      toDate: work.toDate === "" ? null : work.toDate,
    }));
    const finalData={
      previousWork:submitData
    }
    // console.log("finalData>>>>>>>>>>",finalData);

    const options = {
      method: "POST",
      data: finalData,
    };
    let API =
      apiUrl?.add_previous_work +
      `?userId=${
        locationData?.id ? locationData?.id : pageStatesMain?.Id_onCreateEmp
      }`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        setPageStatesMain((prev) => ({
          ...prev,
          activeTab: 8,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };


  return (
    <>
     <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-12">
          <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
            Previous Work
          </h4>
        </div>
        {fields.length > 0 ? (
          fields.map((field, index) => (
            <div className="col-12 mb-3" key={field.id}>
              <div className="card border">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => remove(index)}
                      >
                        Remove
                      </button>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor={`companyName-${index}`} className="form-label">
                          Company Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id={`companyName-${index}`}
                          placeholder="Enter Company Name"
                          {...register(`previousWork.${index}.companyName`, {
                            required: "This field is Required",
                          })}
                        />
                        {errors?.previousWork?.[index]?.companyName && (
                          <div className="form-text text-danger">
                            {errors.previousWork[index].companyName.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor={`designationName-${index}`} className="form-label">
                          Designation Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id={`designationName-${index}`}
                          placeholder="Enter Designation Name"
                          {...register(`previousWork.${index}.designationName`, {
                            required: "This field is Required",
                          })}
                        />
                        {errors?.previousWork?.[index]?.designationName && (
                          <div className="form-text text-danger">
                            {errors.previousWork[index].designationName.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor={`fromDate-${index}`} className="form-label">
                          From <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name={`previousWork.${index}.fromDate`}
                          control={control}
                          rules={{
                            required: "This field is Required",
                          }}
                          render={({ field }) => (
                            <DatePicker size="sm"
                              {...field}
                              id={`fromDate-${index}`}
                              format="dd/MM/yyyy"
                              oneTap
                              placeholder="dd/mm/yyyy"
                              style={{ width: "100%" }}
                              value={field.value ? new Date(field.value) : null}
                              onChange={(date) => {
                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                              }}
                              shouldDisableDate={(date) => date > new Date()}
                              cleanable={false}
                            />
                          )}
                        />
                        {errors?.previousWork?.[index]?.fromDate && (
                          <div className="form-text text-danger">
                            {errors.previousWork[index].fromDate.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor={`toDate-${index}`} className="form-label">
                          To <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name={`previousWork.${index}.toDate`}
                          control={control}
                          rules={{
                            required: !currentCompanyStates[index]
                              ? "This field is Required"
                              : false,
                          }}
                          render={({ field }) => (
                            <DatePicker size="sm"
                              {...field}
                              id={`toDate-${index}`}
                              format="dd/MM/yyyy"
                              oneTap
                              placeholder="dd/mm/yyyy"
                              style={{ width: "100%" }}
                              value={field.value ? new Date(field.value) : null}
                              onChange={(date) => {
                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                              }}
                              shouldDisableDate={(date) => 
                                date > new Date() || 
                                (watch(`previousWork.${index}.fromDate`) && 
                                 date < new Date(moment(watch(`previousWork.${index}.fromDate`)).startOf('day')))
                              }
                              disabled={currentCompanyStates[index]}
                              cleanable={false}
                            />
                          )}
                        />
                        {errors?.previousWork?.[index]?.toDate && (
                          <div className="form-text text-danger">
                            {errors.previousWork[index].toDate.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 align-self-end">
                      <div className="form-check form-group mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`current-${index}`}
                          checked={!!currentCompanyStates[index]}
                          onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor={`current-${index}`}>
                          Current Company
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="d-flex justify-content-center my-4 text-muted">
            <h3 className="border rounded p-3">No Previous Work</h3>
          </div>
        )}
      </div>
      <div className="d-flex align-items-center justify-content-between gap-4 mt-4">
        <button
          type="button"
          className="btn btn-primary px-5"
          onClick={() =>
            append({ companyName: "", designationName: "", fromDate: "", toDate: "" })
          }
        >
          {fields?.length > 0 ? "Add More" : "Add"}
        </button>
        <button className="btn btn-primary px-4" type="submit">
          {isLoading ? <Spinner/> : "Save and Continue"}
        </button>
      </div>
    </form>
    </>
  );
}
